import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReader = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 27 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19 2C22.314 2 25 4.686 25 8C25 11.314 22.314 14 19 14H11C7.686 14 5 11.314 5 8C5 4.686 7.686 2 11 2H19ZM11 0C6.582 0 3 3.582 3 8C3 12.418 6.582 16 11 16H19C23.418 16 27 12.418 27 8C27 3.582 23.418 0 19 0H11ZM21 6C19.895 6 19 6.895 19 8C19 9.105 19.895 10 21 10C22.105 10 23 9.105 23 8C23 6.895 22.105 6 21 6Z"
	}), /* @__PURE__ */ _jsx("path", { d: "M0.878049 9H4V7H0.878049C-0.292683 7 -0.292683 9 0.878049 9Z" })]
});
export default SvgReader;
